import React, { useRef, useState, useEffect } from "react";
import Modals from "./Modals";
import ModalTabBar from "./ModalTabBar";
import { connect } from "react-redux";

const GlobalModal = ({ modal }) => {
  const [
    globalModalOverBootstrapModal,
    setGlobalModalOverBootstrapModal,
  ] = useState(false);
  const [tabNumber, setTabNumber] = useState(false);
  useEffect(() => {
    Object.values(modal).forEach((i) => {
      if (i.type === "minimized") {
        setTabNumber(true);
      }
      if (i.setGlobalModalOverBootstrapModal) {
        setGlobalModalOverBootstrapModal(true);
      }
    });
    if (!Object.values(modal).length) {
      setTabNumber(false);
    }

    return () => setGlobalModalOverBootstrapModal(false);
  }, [modal]);
  return (
    <>
      <div
        className={`globalModal ${
          globalModalOverBootstrapModal ? "globalModalOverBootstrapModal" : ""
        }`}
      >
        <div className="modalContainer">
          <Modals />
        </div>
        {tabNumber && (
          <div className="modalTabBar">
            <ModalTabBar />
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    modal: state.GlobalModal.modals,
  };
};

export default connect(mapStateToProps)(GlobalModal);
